<template>
  <div v-if="hasAccountLocations">
    <i class="far fa-map-marker-alt mr-2"></i> {{filteredLocationListDisplay}}
  </div>
</template>


<script>
import _ from 'lodash'

export default {
  name: 'ReportFilterDisplayAccountLocation',
  props: {
    accountLocationId: [Array, Number]
  },
  computed: {
    accountLocationLookup() {
      return (this.$store.state.account.accountLocations || []).filter(location => location.isActive).map(location => {
        return {
          name: location.name,
          value: location.id,
          colour: location.highlightColour
        }
      })
    },
    hasAccountLocations() {
      if(_.isArray(this.accountLocationId))
        return this.accountLocationId.length > 0
      else
        return this.accountLocationId > 0
    },
    filteredLocationListDisplay() {
      if (!this.hasAccountLocations)
        return ''

      if(!_.isArray(this.accountLocationId)) {
        const location = this.accountLocationLookup.find(loc => loc.value === this.accountLocationId)
        return location ? location.name : ''
      }

      return this.accountLocationId.map(id => {
        const location = this.accountLocationLookup.find(loc => loc.value === id)
        return location ? location.name : ''
      }).join(', ')
    }
  }
}
</script>